import { Link } from '@tanstack/react-router';
import { Card, CardHeader, CardTitle, CardContent, Button, ChecklistItem, ProgressBar, Skeleton } from '@/components/ui';
import { partnerApi } from '@/lib/api-affiliate';

/** WelcomeChecklist — onboarding 4-step list. Hidden when complete. */
export default function WelcomeChecklist() {
  const { data, isLoading } = partnerApi.onboarding.useStatus();

  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Старт за 90 секунд</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <Skeleton className="h-2 w-full" />
          <div className="flex flex-col gap-2">
            <Skeleton className="h-14 w-full" />
            <Skeleton className="h-14 w-full" />
            <Skeleton className="h-14 w-full" />
            <Skeleton className="h-14 w-full" />
          </div>
        </CardContent>
      </Card>
    );
  }

  if (!data) return null;
  const { pickedOffer, createdLink, firstClick, firstConversion } = data;
  const doneCount = [pickedOffer, createdLink, firstClick, firstConversion].filter(Boolean).length;
  if (doneCount === 4) return null;

  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle className="truncate min-w-0">Старт за 90 секунд</CardTitle>
        <span className="text-[11px] uppercase tracking-[0.14em] font-semibold text-[var(--text-muted)] tabular-nums shrink-0">
          Шаг {doneCount} из 4
        </span>
      </CardHeader>
      <CardContent className="flex flex-col gap-3">
        <ProgressBar value={doneCount / 4} />
        <div className="flex flex-col gap-2">
          <ChecklistItem
            done={pickedOffer}
            title="Выбери оффер"
            description="Подбери продукт, который подходит твоей аудитории"
            action={
              !pickedOffer ? (
                <Link to={'/offers' as never}>
                  <Button size="sm" variant="secondary">Открыть каталог</Button>
                </Link>
              ) : undefined
            }
          />
          <ChecklistItem
            done={createdLink}
            title="Создай первую ссылку"
            description="Трекинг-ссылка нужна, чтобы конверсии засчитывались тебе"
            action={
              !createdLink ? (
                <Link to={'/links?create=1' as never}>
                  <Button size="sm" variant="secondary">Создать ссылку</Button>
                </Link>
              ) : undefined
            }
          />
          <ChecklistItem
            done={firstClick}
            title="Запусти трафик"
            description="Размести ссылку в Telegram, у блогеров, в постах"
            action={
              !firstClick ? (
                <Link to={'/links' as never}>
                  <Button size="sm" variant="secondary">Открыть ссылки</Button>
                </Link>
              ) : undefined
            }
          />
          <ChecklistItem
            done={firstConversion}
            title="Дождись первой конверсии"
            description="Обычно появляется в течение нескольких часов после старта трафика"
          />
        </div>
      </CardContent>
    </Card>
  );
}
